export default __webpack_public_path__ + "static/media/checkbox-unchecked.ebc79700.svg";